import CreditUsage from "../../../ui/CreditUsage";

export default function UsageActivity() {
  const breadcrumbs = [
    { name: "Home", path: "/super-admin/dashboard", id: "home" },
    {
      name: "Usage Activity",
      path: "/super-admin/usage-activity",
      isLast: true,
      id: "usage-activity",
    },
  ];

  return (
    <CreditUsage
      role="superadmin"
      showTypeSelector={true}
      showInstituteName={true}
      breadcrumbs={breadcrumbs}
    />
  );
}
